import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseB2BOrders() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getOrderList = (state, myPC, search, callback, bool) => {
    MyAxios.get(
      `Admin_Marketing_B2BOrders?w=${search}&y=${state.year}&m=${state.month}`,
      {
        headers: {
          IsPage: bool,
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.put(`Admin_Marketing_B2BOrders/update`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت آپدیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const assignOffer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Marketing_B2BOrders/assign`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const confirmOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Marketing_B2BOrders/confirm`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const getSMSTemplate = (callback) => {
    MyAxios.get(`Admin_Marketing_B2BOrders/sms/template`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const sendSMS = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Marketing_B2BOrders/sms`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getOrderList,
    updateOrder,
    assignOffer,
    confirmOrder,
    sendSMS,
    getSMSTemplate,
  };
}
